/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Signoffdatethroughadmin3Inputs */

const en__field_signoffdatethroughadmin3 = /** @type {(inputs: _Field_Signoffdatethroughadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`signoff (through admin)`)
};

const de__field_signoffdatethroughadmin3 = /** @type {(inputs: _Field_Signoffdatethroughadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmeldung (durch Veranstalter)`)
};

/**
* | output |
* | --- |
* | "signoff (through admin)" |
*
* @param {_Field_Signoffdatethroughadmin3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_signoffdatethroughadmin3 = /** @type {((inputs?: _Field_Signoffdatethroughadmin3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Signoffdatethroughadmin3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_signoffdatethroughadmin3(inputs)
	return de__field_signoffdatethroughadmin3(inputs)
});
export { _field_signoffdatethroughadmin3 as "_field_signoffDateThroughAdmin" }